"use strict";
// Event Handler
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventHandler = void 0;
// const subscribeToStandardToken = async (tokenTopic: number, callback: (standard: StandardModel) => void) => {
// }
// const subscribeToStandardAddress = async (addressTopic: string, callback: (data: DataModel[]) => void) => {
// }
// const subscribeToDataToken = async (tokenTopic: number, callback: (data: DataModel[]) => void) => {
// }
// const subscribeToDataAddress = async (addressTopic: string, callback: (data: DataModel[]) => void) => {
// }
// TODO - Array filter api endpoints
// TODO - Other contract endpoints
exports.eventHandler = {
    subscribe: {
    // standards: {
    //     new: {
    //         token: subscribeToStandardToken,
    //         address: subscribeToStandardAddress
    //     }
    // },
    // data: {
    //     new: {
    //         token: subscribeToDataToken,
    //         address: subscribeToDataAddress
    //     }
    // }
    }
};
